/* Pacific Tire & Wheel - put the shopper's vehicle on the order.
   Saves the Shop-by-Vehicle choice (or what they type on the cart) as the cart attribute "Vehicle",
   which shows on the order in Shopify admin under "Additional details". */
(function () {
  'use strict';
  var ATTR = 'Vehicle';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cartVehicle = null; // last known value on the cart

  function saved() { try { return window.PTW && PTW.get ? PTW.get() : null; } catch (e) { return null; } }
  function vname(v) { return v ? String(v.name + (v.drive ? ' ' + v.drive : '')).slice(0, 100) : ''; }

  function getCart() {
    return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function setAttr(val) {
    var a = {}; a[ATTR] = val;
    return fetch(root + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: a })
    }).then(function (r) { return r.json(); }).then(function (c) { cartVehicle = (c.attributes && c.attributes[ATTR]) || ''; return c; });
  }

  // On load: if the cart has no vehicle yet, fill it from the saved vehicle
  function syncFromSaved(force) {
    var n = vname(saved()); if (!n) return Promise.resolve();
    return getCart().then(function (c) {
      cartVehicle = (c.attributes && c.attributes[ATTR]) || '';
      if (force ? cartVehicle !== n : !cartVehicle) return setAttr(n).then(fillBoxes);
      fillBoxes();
    }).catch(function () { });
  }

  /* ---------- "Your vehicle" box above the checkout button (cart page + cart drawer) ---------- */
  var CSS = '.ptw-cart-veh{display:flex;flex-direction:column;gap:6px;margin:0 0 12px;text-align:left}' +
    '.ptw-cart-veh label{font-weight:700;font-size:.92rem}.ptw-cart-veh label small{font-weight:400;opacity:.7}' +
    '.ptw-cart-veh input{height:44px;padding:0 12px;border:1.5px solid rgba(0,0,0,.2);border-radius:8px;font:inherit;font-size:1rem;background:#fff;color:#111;width:100%;box-sizing:border-box}' +
    '.ptw-cart-veh .ptw-cv-msg{font-size:.8rem;opacity:.75;min-height:1em}';
  function css() { if (document.getElementById('ptw-cart-veh-css')) return; var s = document.createElement('style'); s.id = 'ptw-cart-veh-css'; s.textContent = CSS; document.head.appendChild(s); }

  function fillBoxes() {
    var val = cartVehicle || vname(saved());
    document.querySelectorAll('.ptw-cart-veh input').forEach(function (i) { if (document.activeElement !== i && !i.dataset.dirty) i.value = val; });
  }

  function addBoxes() {
    var btns = document.querySelectorAll('button[name="checkout"], input[name="checkout"], #checkout');
    btns.forEach(function (b) {
      var host = b.closest('.cart__ctas, .cart-actions, .cart__checkout-button, form') || b.parentNode;
      if (!host || !host.parentNode) return;
      var scope = host.parentNode;
      if (scope.querySelector('.ptw-cart-veh')) return;
      css();
      var id = 'ptw-cv-' + Math.random().toString(36).slice(2, 8);
      var w = document.createElement('div'); w.className = 'ptw-cart-veh';
      w.innerHTML = '<label for="' + id + '">Your vehicle <small>(year, make &amp; model, optional)</small></label>' +
        '<input id="' + id + '" type="text" maxlength="100" autocomplete="off" placeholder="e.g. 2024 Ford F-150 4WD">' +
        '<span class="ptw-cv-msg">Helps us make sure everything fits.</span>';
      scope.insertBefore(w, host);
      var inp = w.querySelector('input'), msg = w.querySelector('.ptw-cv-msg'), t = null;
      inp.value = cartVehicle || vname(saved());
      function save() {
        var v = inp.value.trim().slice(0, 100);
        if (v === (cartVehicle || '')) return Promise.resolve();
        msg.textContent = 'Saving…';
        return setAttr(v).then(function () { inp.dataset.dirty = ''; msg.textContent = v ? 'Saved to your order.' : 'Helps us make sure everything fits.'; fillBoxes(); })
          .catch(function () { msg.textContent = 'Could not save. You can also text us at (559) 666-1893.'; });
      }
      inp.addEventListener('input', function () { inp.dataset.dirty = '1'; clearTimeout(t); t = setTimeout(save, 700); });
      inp.addEventListener('change', save);
      // make sure a typed value is saved before leaving for checkout
      b.addEventListener('click', function (e) {
        if (!inp.dataset.dirty) return;
        e.preventDefault(); e.stopImmediatePropagation(); clearTimeout(t);
        save().then(function () { inp.dataset.dirty = ''; b.click(); });
      }, true);
    });
  }

  function boot() {
    syncFromSaved(false);
    addBoxes();
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(addBoxes, 150); }).observe(document.body, { childList: true, subtree: true });
    // picking/changing a vehicle with the Shop by Vehicle picker updates the cart
    document.addEventListener('ptw:vehicle', function (e) { if (e.detail) syncFromSaved(true); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
